/**
 * Created by zeitler on 12-01-2017.
 */
( function( factory ) {
	if ( typeof define === "function" && define.amd ) {

		// AMD. Register as an anonymous module.
		define( [ "../widgets/datepicker" ], factory );
	} else {

		// Browser globals
		factory( jQuery.datepicker );
	}
}( function( datepicker ) {

datepicker.regional.pt = {
	closeText: "Perto",
	prevText: "Anterior",
	nextText: "Seguinte",
	currentText: "Hoje",
	monthNames: [ "janeiro", "fevereiro", "março", "abril", "maio", "junho",
        "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"],
	monthNamesShort: [ "jan.", "fev.", "mar.", "abr.", "mai.", "jun.",
		"jul.", "ags.", "set.", "out.", "nov.", "dez." ],
	dayNames: [ "domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado" ],
	dayNamesShort: [ "dom.", "seg.", "ter.", "qua.", "qui.", "sex.", "sab." ],
	dayNamesMin: [ "D","S","T","Q","Q","S","S" ],
	weekHeader: "Sem.",
	dateFormat: "dd/mm/yy",
	firstDay: 1,
	isRTL: false,
	showMonthAfterYear: false,
	yearSuffix: "" };
datepicker.setDefaults( datepicker.regional.pt );

return datepicker.regional.pt;

} ) );